<style lang="scss" scoped>
  @import "./federatedID.scss";
</style>

<script>
import { CONSTANT } from '../../../utils/constant.js'
import ConfigurationService from '../configuration.service'
import api from '../../../actions/api.actions'
import traceService from '../../shared/trace/trace-service'
import utils from '../../../utils/utils'
import toasterService from '../../../utils/toaster.js'
import messages from '../../../messages.js'
import { mapGetters } from 'vuex'

const configurationService = new ConfigurationService()

export default {

  data () {
    return {
      CONSTANT: CONSTANT,
      configurationManager: configurationService,
      selectedIssuer: null,
      dropdownOptions: {},
      jwtPayloadSTR: null,
      isjwtPayloadEdited: false,
      issuer: '',
      kid: ''
    }
  },

  computed: {
    ...mapGetters(['jwtPayload', 'environment', 'srcEntityIds', 'srcId']),
    jwtOnOff: {
      get () {
        return this.$store.state.configuration.jwtOnOff
      },

      set (value) {
        this.$store.dispatch('updateJwtOnOff', value)
      }
    }
  },
  watch: {
    jwtOnOff: {
      handler () {
        this.getJwtFlag()
      }
    },
    srcId: {
      handler () {
        this.parseStringToOptions()
      }
    }
  },

  created () {
    this.jwtPayloadSTR = JSON.stringify(this.jwtPayload, undefined, 4)
    this.parseStringToOptions()
    this.updateJwtConfig()
  },
  methods: {

    updateJwtConfig () {
      for (const [issuer, kidValue] of Object.entries(this.dropdownOptions)) {
        if (kidValue === this.selectedIssuer) {
          this.issuer = issuer
          this.kid = kidValue
          break
        }
      }
      this.refreshJwtPayload()
    },

    updateJayPayloadValues () {
      this.isjwtPayloadEdited = true
      if (utils.isJsonString(this.jwtPayloadSTR)) {
        this.$store.commit('updateJwtPayload', JSON.parse(this.jwtPayloadSTR))
      } else {
        if (this.jwtPayloadSTR.trim() === '') {
          this.$store.commit('updateJwtPayload', {})
        }
      }
    },

    /**
     * Parses a string of comma-separated key-value pairs from `fedTokenIssuers` and populates the `dropdownOptions` object.
     * */
    parseStringToOptions () {
      const options = {}
      if (this.srcId.srci[0]?.additionalProperty?.fedTokenIssuers) {
        const pairs = this.srcId.srci[0].additionalProperty.fedTokenIssuers.toString().split(',')
        pairs.forEach(pair => {
          const [key, value] = pair.split(' = ').map(item => item.trim())
          options[key] = value
        })
        this.dropdownOptions = options
        this.selectedIssuer = Object.values(this.dropdownOptions)[0] || ''
      }
    },

    /**
       * This method call the isRecognize and clear the federatedToken when jwt flag is off
       *
       * */
    getJwtFlag () {
      if (this.jwtOnOff === 'off') {
        this.$store.dispatch('updateFederatedToken', '')
        if (!configurationService.getSrcTransactionId()) {
          this.srcTransactionId = ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, a => (a ^ Math.random() * 16 >> a / 4).toString(16))
          this.$store.commit('srcTransactionId', this.srcTransactionId)
        }
      }
      // else if (this.jwtOnOff === 'on' && this.$store.state.configuration.federatedToken) {
      // let mc = mcIsRecognized(this.$store.state.lightboxstore.lightbox.srcTransactionId)
      // this.$store.commit('recognized', mc)
      // }
    },

    /**
       * This method calls the Masterpass MTT to get the JWT based on given json
       * @param jwtPayload
       * @returns {Promise<void>}
       */
    async postFederatedId (jwtPayload) {
      let startDate = new Date()
      let payload = {
        jsonPayload: jwtPayload,
        environmentId: this.environment,
        srciClientId: this.srcEntityIds[0].srci[0].srcInitiatorId
      }

      try {
        traceService.addRequestLogs({
          methodName: CONSTANT.TRACE.METHOD.GET_FEDERETED_TOKEN,
          params: jwtPayload
        })
        const response = await api.getFederatedTokenStart(payload)
        this.$store.dispatch('updateFederatedToken', response.signedJsonPayload)
        const endDate = new Date()
        const timeTakenData = utils.getTimeTakenDetail(startDate, endDate)
        traceService.addResponseLogs(CONSTANT.TRACE.METHOD.GET_FEDERETED_TOKEN, JSON.stringify(response.signedJsonPayload), '')
        traceService.addTimeTaken(CONSTANT.TRACE.METHOD.GET_FEDERETED_TOKEN, timeTakenData, CONSTANT.SRCSDK_MASTERCARD_NTW)
        toasterService.onSuccess(messages['en-US'].successMessages.FEDERATED_TOKEN_SUCCESS)
      } catch (error) {
        if (error.response && error.response.data) {
          const timeTakenData = utils.getTimeTakenDetailsWhenError(startDate, CONSTANT.ERROR_MSG.apiFailureMsg)
          traceService.addTimeTaken(CONSTANT.TRACE.METHOD.GET_FEDERETED_TOKEN, timeTakenData, CONSTANT.SRCSDK_MASTERCARD_NTW)
          traceService.addResponseLogs(CONSTANT.TRACE.METHOD.GET_FEDERETED_TOKEN, JSON.stringify(error.response.data), '')
          toasterService.onFailure(messages['en-US'].errorMessages.FEDERATED_TOKEN_ERROR)
        }
      }
    },

    refreshJwtPayload () {
      const currentTS = Math.floor(Date.now() / 1000)
      const fifteenMinAheadTS = Math.floor((Date.now() + 15 * 60 * 1000) / 1000)
      let valueUpdate = JSON.parse(this.jwtPayloadSTR)
      if (this.kid && this.kid !== '') {
        valueUpdate[0].kid = this.kid
      }
      if (this.issuer && this.issuer !== '') {
        valueUpdate[1].iss = this.issuer
      }
      valueUpdate[1].auth_time = currentTS
      valueUpdate[1].iat = currentTS
      valueUpdate[1].exp = fifteenMinAheadTS
      this.jwtPayloadSTR = JSON.stringify(valueUpdate, undefined, 4)
      this.updateJayPayloadValues()
    }
  }
}
</script>

<template>
  <div
    id="configuration-federatedID"
  >
    <div class="card mb-4">
      <h5
        id="headingJWTTesting"
        aria-controls="collapseDynamicJwtTesting"
        aria-expanded="true"
        class="card-header collapsed cursor-pointer"
        data-target="#collapseDynamicJwtTesting"
        data-toggle="collapse"
      >
        <span class="font-weight-bold">{{ $t ('header.jwtTest') }}</span>
        <span class="collapsible-arrow pull-right" />
      </h5>
      <div
        id="collapseDynamicJwtTesting"
        aria-labelledby="headingJWTTesting"
        class="card-body collapse show"
      >
        <div class="row">
          <div class="col-sm-12 ">
            {{ $t ('label.jwtTestingEnable') }}
          </div>
        </div>
        <div
          id="jwt-preference"
          class="row mt-3"
        >
          <div class="col-sm-12">
            <label
              v-for="(key, value) in CONSTANT.CONFIG.JWT_TESTING_ENABLE"
              :key="value"
              class="jwt-OnOff"
            >
              <input
                :id="'radio-' + key"
                v-model="jwtOnOff"
                :value="key"
                type="radio"
              >
              <div class="btn">{{ value }}</div>
            </label>
            <div class="clear" />
          </div>
        </div>
        <div
          id="SRCI-entity-ID"
          class="row mt-4"
          data-test="Jwt-issuer"
        >
          <div class="col-sm-10">
            {{ $t ('label.issuer') }}
          </div>
          <div class="col-sm-12">
            <select
              id="jwt-issuer"
              v-model="selectedIssuer"
              class="option-dpa form-control"
              data-test="jwt-issuer"
              @change="updateJwtConfig"
            >
              <option
                v-for="(value, key) in dropdownOptions"
                :key="key"
                :value="value"
              >
                {{ key }}
              </option>
            </select>
          </div>
        </div>

        <div class="row mt-4 px-3 d-flex justify-content-between">
          <div class="pt-3">
            {{ $t ('label.jwtPayload') }}
          </div>
          <button
            id="jwt-refresh-btn"
            class="btn btn-primary btn-lg"
            title="Refresh JWT"
            @click="refreshJwtPayload"
          >
            {{ $t ('label.refresh') }}
          </button>
        </div>
        <div class="row mt-2">
          <div class="col-sm-12">
            <textarea
              v-validate="{ validJson: true }"
              id="input-jwtPayload"
              v-model="jwtPayloadSTR"
              :class="{ 'is-invalid': errors.has('jwtPayload') }"
              class="form-control"
              required
              rows="20"
              cols="67"
              name="jwtPayload"
              placeholder=""
              @input="updateJayPayloadValues(errors.has('jwtPayload'))"
            />
            <span
              v-if="isjwtPayloadEdited && errors.has('jwtPayload')"
              class="invalid-feedback"
            >{{ errors.first("jwtPayload") }}
            </span>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-sm-12">
            <button
              id="generate-btn"
              :class="[jwtOnOff == 'on' && jwtPayload ? 'btn-primary' : 'btn-secondary disabled']"
              :disabled="jwtPayload === ''"
              class="btn"
              data-cy="generate-button"
              type="button"
              @click="postFederatedId(jwtPayload)"
            >
              {{ $t ('label.generate') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
